import { View } from "react-native-web";
import { CImage } from "../../../components/atoms";
import { Constants, Images } from "../../../config";

export const parkfulFilterCriteria = (isMobileVersion, styles) => {
  return [
    {
      title: "Location",
      isHide: isMobileVersion,
      isLocation: true,
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_STATUS,
      icon: Images.iconTagStatus,
      width: 20,
      height: 20,
      title: "Status",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Open",
          tagId: 1,
        },
        {
          id: 2,
          label: "Closed",
          tagId: 2,
        },
        {
          id: 3,
          label: "Temporarily Closed",
          tagId: 4,
        },
        {
          id: 4,
          label: "Permanently Closed",
          tagId: 3,
        },
      ],
      selectedList: [1, 2, 4],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_AMENITIES,
      icon: Images.iconTagAmenities,
      width: 20,
      height: 20,
      title: "Amenities",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Hotel",
          tagId: 52,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_PARKFUL_CATEGORY,
      icon: Images.iconTagFeature,
      width: 20,
      height: 20,
      title: "Category",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Theme Park",
          tagId: 5501,
        },
        {
          id: 2,
          label: "Waterpark",
          tagId: 5502,
        },
        {
          id: 3,
          label: "Waterplay",
          tagId: 5503,
        },
        {
          id: 4,
          label: "Dark Ride Park",
          tagId: 5504,
        },
        {
          id: 5,
          label: "Ride Park",
          tagId: 5505,
        },
        {
          id: 6,
          label: "Children’s Role Play",
          tagId: 5506,
        },
        {
          id: 7,
          label: "Family Entertainment Center",
          tagId: 5507,
        },
        {
          id: 8,
          label: "Children’s Playroom",
          tagId: 5508,
        },
        {
          id: 9,
          label: "Trampoline Park",
          tagId: 5509,
        },
        {
          id: 10,
          label: "Escape Room",
          tagId: 5510,
        },
        {
          id: 11,
          label: "VR Attraction",
          tagId: 5511,
        },
        {
          id: 12,
          label: "Surf Wave",
          tagId: 5512,
        },
        {
          id: 13,
          label: "Laser Tag",
          tagId: 5513,
        },
        {
          id: 14,
          label: "Go Karts",
          tagId: 5514,
        },
        {
          id: 15,
          label: "Indoor Skydive",
          tagId: 5515,
        },
        {
          id: 16,
          label: "Bowling",
          tagId: 5516,
        },
        {
          id: 17,
          label: "Minigolf",
          tagId: 5517,
        },
        {
          id: 18,
          label: "Resort Park",
          tagId: 5518,
        },
        {
          id: 19,
          label: "Marine Animal",
          tagId: 5519,
        },
        {
          id: 20,
          label: "Show Based",
          tagId: 5520,
        },
        {
          id: 21,
          label: "Cultural Attraction",
          tagId: 5521,
        },
        {
          id: 22,
          label: "Adventure Park",
          tagId: 5522,
        },
        {
          id: 23,
          label: "Agricultural Attraction",
          tagId: 5523,
        },
        {
          id: 24,
          label: "Indoor Ice, Ski & Snow",
          tagId: 5524,
        },
        {
          id: 25,
          label: "Marine Interaction",
          tagId: 5525,
        },
        {
          id: 26,
          label: "Gardens",
          tagId: 5526,
        },
        {
          id: 27,
          label: "Wildlife-Based Attraction",
          tagId: 5527,
        },
        {
          id: 28,
          label: "Animal-based attractions",
          tagId: 5528,
        },
        {
          id: 29,
          label: "Minilands",
          tagId: 5529,
        },
        {
          id: 30,
          label: "Factory Tours",
          tagId: 5530,
        },
        {
          id: 31,
          label: "Art and Culture Museums",
          tagId: 5531,
        },
        {
          id: 32,
          label: "Interactive Museums",
          tagId: 5532,
        },
        {
          id: 33,
          label: "Observatory/Wheels",
          tagId: 5533,
        },
        {
          id: 34,
          label: "Flying Theater",
          tagId: 5534,
        },
        {
          id: 35,
          label: "Dinner Theater",
          tagId: 5535,
        },
        {
          id: 36,
          label: "Themed Village",
          tagId: 5536,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_PARKFUL_SIZE,
      icon: Images.iconTagSize,
      width: 20,
      height: 20,
      title: "Size",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "XS - 0-20k sqm",
          tagId: 5601,
        },
        {
          id: 2,
          label: "S - 20-100k sqm",
          tagId: 5602,
        },
        {
          id: 3,
          label: "M - 100-1,000k sqm",
          tagId: 5603,
        },
        {
          id: 4,
          label: "L - 1,000-5,000k sqm",
          tagId: 5604,
        },
        {
          id: 5,
          label: "XL - +5,000k sqm",
          tagId: 4605,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_RATING,
      icon: Images.iconTagRating,
      width: 21.5,
      height: isMobileVersion ? 21 : 20,
      title: "Rating",
      isHide: true,
      isRating: true,
      detailList: [
        {
          id: 1,
          label: "1",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating1}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 2,
          label: "2",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating2}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 3,
          label: "3",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating3}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 4,
          label: "4",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating4}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 5,
          label: "5",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating5}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
      ],
      selectedList: [],
    },
  ];
};
